import React, { ReactElement, useCallback } from 'react'
import { RuleType } from 'store/api/rules'
import { openProxyTray } from 'store/proxyTray'
import { useAppDispatch } from 'store/hooks'
import { ServiceData } from 'store/api/services'
import { ProxyLocation } from 'store/api/proxies'
import { globeIcon, IconType } from 'components/Dashboard/CommonComponents/ExternalSvgIcon'
import ActionButton, { ActionType } from '../RuleActionButtons/ActionButton'

interface RedirectButtonProps {
  serviceRule: ServiceData
  isSwitchChecked: boolean
  setRedirectButtonHover?: (x: boolean) => void
  // this method is passed the service item handleclick which is only used if the service is not active
  onFirstClick: () => void
  redirectLocation?: ProxyLocation
}
export default function RedirectButton({
  serviceRule,
  isSwitchChecked,
  setRedirectButtonHover = (): void => {},
  onFirstClick,
  redirectLocation,
}: RedirectButtonProps): ReactElement {
  const dispatch = useAppDispatch()

  const openProxyList = useCallback(() => {
    dispatch(
      openProxyTray({
        rule: serviceRule,
      }),
    )
  }, [dispatch, serviceRule])

  const proxyIcon = redirectLocation?.country || ''

  const isSpoofed = serviceRule?.action?.do === RuleType.SPOOF_IP
  const isRedirected = serviceRule?.action?.do === RuleType.SPOOF_TAG

  const isActive = isRedirected || isSpoofed

  const handleClick = useCallback(() => {
    if (!isActive || !isSwitchChecked) {
      onFirstClick()
    } else {
      openProxyList()
    }
  }, [isActive, isSwitchChecked, onFirstClick, openProxyList])

  return (
    <ActionButton
      isService
      showArrow={isSwitchChecked}
      isActive={isActive}
      isSwitchChecked={isSwitchChecked}
      type={ActionType.REDIRECT}
      externalIcon={{
        icon: isSpoofed ? globeIcon : proxyIcon || globeIcon,
        type: IconType.LOCATIONS,
      }}
      testId={`proxy-list-button-${
        redirectLocation?.isSingle
          ? redirectLocation?.country_name
          : redirectLocation?.city ?? (isSpoofed ? 'spoof' : 'redirect')
      }`}
      ariaLabel={`Open Proxy List ${
        redirectLocation
          ? ` - ${
              redirectLocation.isSingle ? redirectLocation.country_name : redirectLocation.city
            } is selected`
          : isSpoofed
          ? ` - Redirected to ${serviceRule?.action?.via}`
          : ''
      }`}
      onClick={handleClick}
      onMouseEnter={(): void => {
        if (isActive) {
          setRedirectButtonHover(true)
        }
      }}
      onMouseLeave={(): void => {
        setRedirectButtonHover(false)
      }}
      onTouchStart={(): void => {
        if (isActive) {
          setRedirectButtonHover(true)
        }
      }}
      onTouchEnd={(): void => setRedirectButtonHover(false)}
    />
  )
}
